// extracted by mini-css-extract-plugin
export default {"avatarImage":"ListingsAvatar-module__avatarImage___3xjK5"};